import React, { useEffect, useState } from "react";
import Markdown from "../common/markdown";
import "./air.css";

const RiskPopupImp = ({ popupDescription }) => {
  const [currentPopup, setCurrentPopup] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [description, setDescription] = useState("");

  useEffect(() => {
    console.log("Popup content:", popupDescription);
    setDescription(popupDescription);
  }, [popupDescription]);

  const handlePopup = (id) => {
    setCurrentPopup(description[id]);
    console.log("Opening:", id);
    setShowPopup(true);
  };

  return (
    <>
      <ul className="risk-popup-container">
        {description &&
          description.map((item, index) => {
            return (
              <li
                key={index}
                className="risk-popup-item"
                onClick={handlePopup.bind(this, index)}
              >
                <div className="img-container">
                  <img src={item.imageURL} alt="{item.title}" />
                </div>
              </li>
            );
          })}
      </ul>

      {/* Overlay */}
      {showPopup && currentPopup && (
        <div
          className="risk overlay-panel-container"
          onClick={() => setShowPopup(false)}
        >
          <div className="overlay-panel" onClick={(e) => e.stopPropagation()}>
            {/* Prevents closing when clicking inside the panel */}

            <div className="header-section">
              <img
                src={currentPopup.popupIconURL}
                alt={currentPopup.popupIconAltText}
                className="icon"
              />
              <span className="header-span">
                <h2 className={`colored-title ${currentPopup.color || ""}`}>
                  {currentPopup.title}
                </h2>
                <h3 className={`subtitle ${currentPopup.color || ""}`}>
                  {" "}
                  - {currentPopup.subtitle}
                </h3>
              </span>
            </div>
            <Markdown
              className={`summary ${currentPopup.color || ""}`}
              children={currentPopup.summary}
            />
            <div className="image-right">
              <img
                src={currentPopup.popupImageURL}
                alt={currentPopup.popupImageAltText}
              />
            </div>
            <div className="example-section">
              <div className="green-bold">BEISPIELE:</div>
              <div>
                {currentPopup.exampleLayout === "two-column-layout" ? (
                  <div className="two-column-layout">
                    {currentPopup.examples.map((columnContent, index) => (
                      <Markdown
                        className="air-content"
                        key={index}
                        children={columnContent}
                      />
                    ))}
                  </div>
                ) : (
                  currentPopup.examples.map((example, index) => (
                    <Markdown
                      className="air-content"
                      key={index}
                      children={example}
                    />
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RiskPopupImp;
